import { Trans, useTranslation } from 'react-i18next';
import { DeviceCardProps } from '../DeviceCardProps';
import DriveUnitPortControl from '../Controls/DriveUnitPortControl';
import SliderControl from '../Controls/SliderControl';
import MotorDirectionControl from '../Controls/MotorDirectionControl';
import DropDownControl from '../Controls/DropDownControl';
import { electronics, MOTOR_TYPE } from '../../../../utils/constants';
import DeviceCardWrapper from '../DeviceCardWrapper';
import { useDriveUnitPortRegistry } from '../../../../hooks/controls/useDriveUnitPortRegistry';

interface BaseMotorCardProps extends DeviceCardProps {
  motorType: (typeof MOTOR_TYPE)[keyof typeof MOTOR_TYPE];
  headerIcon: React.ElementType;
}

const BaseMotorCard = (props: BaseMotorCardProps) => {
  const { t } = useTranslation();
  const torqueLimits = electronics[props.motorType];
  const { portControlValue, setPortControlValue, unsupportedRawValue } = useDriveUnitPortRegistry(props, 'motor_port');

  return (
    <DeviceCardWrapper header={props.header} headerIcon={props.headerIcon} initialOpen={props.initialOpen} onDelete={props.onDelete}>
      <DriveUnitPortControl
        {...props}
        parameterName="motor_port"
        portControlValue={portControlValue}
        setPortControlValue={setPortControlValue}
        unsupportedRawValue={unsupportedRawValue}
        label={<Trans i18nKey="motorControl.port">Motor Port</Trans>}
        labelId="motor-port-label"
        labelPopoverId="motor-port-popover"
        labelPopover={t('motorControl.port_info_tooltip')}
        selectId="motor-port"
        selectLabelId="select-motor-port-label"
      />
      <SliderControl
        {...props}
        parameterName="max_torque"
        label={<Trans i18nKey="motorControl.gear_ratio">Max Torque</Trans>}
        labelId="max-torque"
        labelPopoverId="max-torque-popover"
        labelPopover={t('motorControl.max_torque_info_tooltip')}
        labelUnits="N·m"
        step={0.01}
        min={torqueLimits.MIN_TORQUE}
        max={torqueLimits.MAX_TORQUE}
        shrinkLabel={false}
      />
      <MotorDirectionControl {...props} parameterName="motor_direction" />
      <DropDownControl
        {...props}
        parameterName="stop_mode"
        label={<Trans i18nKey="motorControl.max_position_limit">Stopping Mode</Trans>}
        labelId="stopping-mode"
        labelPopoverId="stopping-mode-popover"
        labelPopover={t('motorControl.stopping_mode_info_tooltip')}
        selectId="stopping-mode"
        selectLabelId="select-stopping-mode-label"
        options={[
          { label: 'Brake', value: 'MotorStopMode.BRAKE' },
          { label: 'Coast', value: 'MotorStopMode.COAST' },
          { label: 'Hold', value: 'MotorStopMode.HOLD' },
        ]}
      />
    </DeviceCardWrapper>
  );
};

export default BaseMotorCard;
